import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import "./newform.css";
import FlexComponent from "../../FlexComponent";
import { useParams } from "react-router-dom";
import { useNewUser } from "../../../APIContext/NewUserContext";
import Swal from "sweetalert2";

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const FormComUser = () => {
  const { cartItemsNew, proceedToCheckoutGuest, verifyPaymentStatusGuest } =
    useNewUser();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [price, setPrice] = useState(0);
  const [pollInterval, setPollInterval] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const [paymentMessage, setPaymentMessage] = useState(
    "Verifying your payment...",
  );

  const [formData, setFormData] = useState({
    parent: {
      email: "",
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      phone: "",
      confirm_password: "",
    },
  });

  useEffect(() => {
    if (cartItemsNew && cartItemsNew.summary) {
      setPrice(cartItemsNew.summary.total);
    }
  }, [cartItemsNew]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      parent: {
        ...prev.parent,
        [name]: value,
      },
    }));
  };

  // const startPaymentPolling = (sessionId) => {
  //     setShowPaymentModal(true);
  //     setPaymentStatus('pending');
  //     setPaymentMessage('Verifying your payment...');

  //     const interval = setInterval(async () => {
  //         try {
  //             const result = await verifyPaymentStatusGuest(sessionId);
  //             if (result?.sales?.payment?.paid === true) {
  //                 clearInterval(interval);
  //                 let loggedInUser = result.payload.user;
  //                 if (loggedInUser?.user) {
  //                   loggedInUser = { ...loggedInUser, ...loggedInUser.user };
  //                 }

  //                 localStorage.setItem("user", JSON.stringify(loggedInUser));
  //                 localStorage.setItem("accessToken", result.payload.access);
  //                 localStorage.setItem("refreshToken", result.payload.refresh);
  //                 setPaymentStatus('success');
  //                 setPaymentMessage('Payment Successful! Redirecting...');
  //                 setTimeout(() => {
  //                     window.location.href = '/your-packages';
  //                 }, 2500);
  //             }
  //         } catch (err) {
  //             console.log('Still waiting...');
  //         }
  //     }, 3000);

  //     setPollInterval(interval);

  //     setTimeout(() => {
  //         if (paymentStatus === 'pending') {
  //             clearInterval(interval);
  //             setPaymentStatus('failed');
  //             window.location.href = '/payment-failed';
  //             setPaymentMessage('Payment timed out. Contact support.');
  //         }
  //     }, 10 * 60 * 1000);
  // };

  const handleSubmit = async () => {
    const { parent } = formData;

    // 1️⃣ Frontend validation
    if (parent.password !== parent.confirm_password) {
      Swal.fire({
        title: "Password Mismatch",
        text: "Passwords do not match",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#f7931a",
      });
      return;
    }

    // 2️⃣ Remove confirm_password before sending to API
    const payload = {
      parent: {
        first_name: parent.first_name,
        last_name: parent.last_name,
        username: parent.username,
        email: parent.email,
        phone: parent.phone,
        password: parent.password,
      },
    };

    try {
      const response = await proceedToCheckoutGuest(payload);
      if (response?.data?.url) {
        // const sessionId = response.data.id;
        // const win = window.open(response.data.url, '_blank');
        window.open(response.data.url, "_self");
        // if (win) startPaymentPolling(sessionId);
        // else alert('Please allow pop-ups!');
      }
    } catch (err) {
      alert("Checkout failed");
    }
  };

  // useEffect(() => () => pollInterval && clearInterval(pollInterval), [pollInterval]);

  return (
    <>
      {
        <div className="form-wrapper new-user brightness">
          <div className="form-card">
            {/* Add Your Details */}
            <div className="child-details-container">
              <div style={{ marginTop: "1rem" }}>
                <label className="label-bold headings text-clip">
                  Add Your Details
                </label>
              </div>

              <div className="child-details-container-1">
                <div className="form-item-new">
                  <label className="label-bold text-clip">First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-input"
                    value={formData.parent.first_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-item-new">
                  <label className="label-bold text-clip">Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-input"
                    value={formData.parent.last_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-item-new">
                  <label className="label-bold text-clip">Username</label>
                  <input
                    type="text"
                    name="username"
                    className="form-input"
                    value={formData.parent.username}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-item-new">
                  <label className="label-bold text-clip">Phone No</label>
                  <input
                    type="text"
                    name="phone"
                    className="form-input"
                    value={formData.parent.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-item-new">
                  <label className="label-bold text-clip">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    value={formData.parent.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-item-new password-wrapper">
                  <label className="label-bold text-clip">Password *</label>

                  <div className="password-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-input"
                      value={formData.parent.password}
                      onChange={handleChange}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      {showPassword ? (
                        <i className="ri-eye-off-line"></i>
                      ) : (
                        <i className="ri-eye-line"></i>
                      )}
                    </span>
                  </div>
                </div>

                <div className="form-item-new password-wrapper">
                  <label className="label-bold text-clip">
                    Confirm Password *
                  </label>

                  <div className="password-field">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirm_password"
                      className="form-input"
                      value={formData.parent.confirm_password}
                      onChange={handleChange}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    >
                      {showConfirmPassword ? (
                        <i className="ri-eye-off-line"></i>
                      ) : (
                        <i className="ri-eye-line"></i>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button
                className="add-cart-btn"
                disabled={
                  !formData.parent.first_name ||
                  !formData.parent.last_name ||
                  !formData.parent.email ||
                  !formData.parent.password ||
                  !formData.parent.confirm_password
                }
                onClick={handleSubmit}
              >
                Pay Now – ${price.toFixed(2)}
              </button>
            </div>
          </div>
        </div>
      }

      {/* PAYMENT MODAL */}
      {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "60px 40px",
              borderRadius: "20px",
              textAlign: "center",
              maxWidth: "440px",
              boxShadow: "0 30px 60px rgba(0,0,0,0.4)",
            }}
          >
            {paymentStatus === "pending" && (
              <>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    border: "10px solid #f0f0f0",
                    borderTop: "10px solid #007bff",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 30px",
                  }}
                ></div>
                <h3>Processing Payment</h3>
                <p style={{ color: "#666" }}>{paymentMessage}</p>
              </>
            )}
            {paymentStatus === "success" && (
              <>
                <div style={{ fontSize: "90px", color: "#28a745" }}>✅</div>
                <h3 style={{ color: "#28a745" }}>Payment Successful!</h3>
                <p>{paymentMessage}</p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FormComUser;
